module.exports = __webpack_public_path__ + "static/media/oil-change-white.76a318f4.svg";